import Vue from "vue";
import axios from "axios";

Vue.use({
  install(Vue) {
    Vue.prototype.$http = axios.create({
      baseURL: "https://api.viajar.tur.br/v1",
    });

    Vue.prototype.$http.interceptors.request.use((config) => {
      const token = localStorage.getItem("token");
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    Vue.prototype.$http.interceptors.response.use((res) => {
      return res;
    });

    Vue.prototype.$integrations = axios.create({
      baseURL: "https://integrations.haya.net.br/v1",
    });

    Vue.prototype.$integrations.interceptors.request.use((config) => {
      const token = localStorage.getItem("token");
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    Vue.prototype.$integrations.interceptors.response.use((res) => {
      return res;
    });

    Vue.prototype.$hayaApi = axios.create({
      baseURL: "https://haya.api.viajar.tur.br/v1",
      // http://localhost:8888/v1
      // https://haya.api.viajar.tur.br/v1
    });

    Vue.prototype.$hayaApi.interceptors.request.use((config) => {
      const token = localStorage.getItem("token");
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    Vue.prototype.$hayaApi.interceptors.response.use((res) => {
      return res;
    });
  },
});